var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedTextfieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 2.33 0.67 3 1.5 3H5V13.5C5 14.33 5.67 15 6.5 15C7.33 15 8 14.33 8 13.5V3H11.5C12.33 3 13 2.33 13 1.5C13 0.67 12.33 0 11.5 0H1.5C0.67 0 0 0.67 0 1.5ZM17.5 5H11.5C10.67 5 10 5.67 10 6.5C10 7.33 10.67 8 11.5 8H13V13.5C13 14.33 13.67 15 14.5 15C15.33 15 16 14.33 16 13.5V8H17.5C18.33 8 19 7.33 19 6.5C19 5.67 18.33 5 17.5 5Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedTextfieldIcon);
export default __webpack_public_path__ + "static/media/DeprecatedTextfieldIcon.348cd91010bf56faa330567f60df6f70.svg";
export { ForwardRef as ReactComponent };